import { useState } from 'react';
import { ssoService } from '@services/ssoService';

const isToptanSsoEnabled = import.meta.env.VITE_TOPTAN_SSO_ENABLED !== 'false';

export function ToptanNavButton() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!isToptanSsoEnabled) {
    return null;
  }

  const handleNavigateToToptan = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const { redirectUrl } = await ssoService.initiateToptanSso();
      window.location.assign(redirectUrl);
    } catch {
      setError('Toptan\'a bağlanılamadı. Lütfen tekrar deneyin.');
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-end">
      <button
        type="button"
        onClick={handleNavigateToToptan}
        disabled={isLoading}
        aria-label="Lezzet Yolda Toptan'a geç"
        className="flex items-center gap-2 rounded-2xl bg-secondary/10 px-4 py-2.5 text-sm font-semibold text-secondary transition-all duration-200 hover:bg-secondary/20 hover:scale-105 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {isLoading ? (
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-secondary border-t-transparent" />
        ) : (
          <span className="text-base leading-none" aria-hidden="true">
            🛒
          </span>
        )}
        <span>Toptan</span>
      </button>
      {error && (
        <span className="mt-1 max-w-[200px] text-right text-xs text-red-600">{error}</span>
      )}
    </div>
  );
}
